export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11470.5991c5f3.jpg";